<template>
    <b-form>
      <b-card-header
          v-if="isHeaderVisible"
          class="v3_box_teal_header v3_color_black_knight"
      >
        <b-row>
          <b-col sm="12" md="6" class="align-self-center text-center-mobile">
            <span class="v3_color_teal text-uppercase font_weight_bold text-sm-center">
              {{ user.email }}
            </span>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body class="v3_box_teal_body p-4 p-sm-2">
        <div class="grey-box">
          <div class="border_1 border_grey p-3">
            <recruiter-purchase-history-list 
            :job-offers="jobOffers"
            />
          </div>
        </div>
      </b-card-body>
    </b-form>
  </template>
  
  <script>
  import Api from '@/providers/Api';
  import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
  import RecruiterPurchaseHistoryList from "@/components/users/history/RecruiterPurchaseHistoryList";

  export default {
    name: 'UserPurchaseHistory',
    components: {
        RecruiterPurchaseHistoryList,
    },
    props: {
      saveLoading: {
        type: Boolean,
        default: false,
      },
      isHeaderVisible: {
        type: Boolean,
        default: true,
      },
    },
    data: function () {
        return {
            jobOffers: null,
            loading:this.saveLoading
        }
    },
    created: function () {
        this.purchaseHistory;
    },
    computed: {
        user: function () {
            return this.$store.state.user ? this.$store.state.user : {};
        },
        purchaseHistory: function () {
            return this.getPurchaseHistory();
        },
    },
    methods: {
        getPurchaseHistory: async function () {
            this.loading = true;
            try {
                this.jobOffers = await Api.getUserJobOffers(this.user.id);
            } catch (e) {
                handleServerErrorWithValidation(e, this.$toasted);
            } finally {
                this.loading = false;
            }
        }
    },
  };
  </script>
  
  <style scoped>
  @media (max-width: 768px) {
    .text-center-mobile {
      text-align: center;
      margin-bottom: 0.75rem;
    }
  
    .grey-box {
      padding: 1rem !important;
    } 
  
    .p-sm-2 {
      padding: 0.75rem !important;
    }
  
    .phairify-select-wrapper {
      min-width: unset !important;
    }
  
    .mobile-buttons-profile {
      justify-content: center !important;
    }
  }
  </style>
  
  <style lang="scss" scoped>
  @import '../../../../sass/v3';
  
  .phairify-select-wrapper {
    min-width: 215px;
    width: 100%;
  
    &:after {
      font-size: 22px;
      right: 10px;
    }
  
    .custom-select {
      height: 100%;
      padding: 15px;
    }
  }
  
  .invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    display: block;
  }
  
  /*.grey-box {
    border: none;
    border-radius: 0;
    background-color: rgba($v3_color_black_knight, 0.025);
    padding: 1rem;
  }*/
  </style>
  